const TWELVE_HOURS = 12 * 60 * 60 * 1000;

/**
 * Get the fuel highlight status for a machine.
 * Returns "red" | "green" | null
 */
export function getMachineHighlight(machine, requests) {
  const hasActiveFuelReq = requests.some(
    r => r.machine_id === machine.id && r.request_type === "FUEL" && r.status !== "DONE"
  );
  if (hasActiveFuelReq) return "red";

  if (machine.last_refuel) {
    const refuelTime = new Date(machine.last_refuel).getTime();
    const now = Date.now();
    if (now - refuelTime < TWELVE_HOURS) return "green";
  }
  return null;
}

/**
 * Get the fuel highlight status for a site.
 * Returns "red" | "green" | null
 */
export function getSiteHighlight(site, machines, requests) {
  const siteMachines = machines.filter(m => m.site_id === site.id);
  const hasActiveFuelReq = requests.some(
    r => r.site_id === site.id && r.request_type === "FUEL" && r.status !== "DONE"
  );
  if (hasActiveFuelReq) return "red";

  // Check site-level refuel
  if (site.last_refuel) {
    const refuelTime = new Date(site.last_refuel).getTime();
    if (Date.now() - refuelTime < TWELVE_HOURS) return "green";
  }

  // Check if all machines were recently refueled
  if (siteMachines.length > 0 && siteMachines.every(m => {
    if (!m.last_refuel) return false;
    return Date.now() - new Date(m.last_refuel).getTime() < TWELVE_HOURS;
  })) return "green";

  return null;
}

/**
 * CSS class helpers for highlight colors
 */
export const highlightBorder = (status) => {
  if (status === "red") return "border-red-500/50 shadow-[0_0_12px_rgba(239,68,68,0.15)]";
  if (status === "green") return "border-lime-500 shadow-sm";
  return "border-slate-200";
};

export const highlightBg = (status) => {
  if (status === "red") return "bg-red-500/8";
  if (status === "green") return "bg-lime-500/8";
  return "";
};

export const highlightIcon = (status) => {
  if (status === "red") return "bg-red-600/15 text-red-500";
  if (status === "green") return "bg-lime-500/15 text-lime-600";
  return "bg-slate-100 text-slate-400";
};

export const highlightMachineBadge = (status) => {
  if (status === "red") return "border-red-500/40 bg-red-500/15 text-red-400";
  if (status === "green") return "border-lime-400 bg-lime-500/15 text-lime-600";
  return "border-slate-200 bg-white text-slate-400";
};
